import React from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { addGlobalMessage } from "@api/global_messages"
import { post } from "@src/helpers/fetch"

const UPLOAD_LOGO = 'UPLOAD_LOGO'

const Logo = ({ post, organization, onUploadStart, onUploadComplete, addGlobalMessage, backgroundColor, url }) => {
  const onDrop = files => {
    const file = files[0]
    post(
      UPLOAD_LOGO,
      `organizations/${organization._id}/settings/logo`,
      { fileName: file.name },
      res => {
        onUploadStart()
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', res.signedUrl);
        xhr.onreadystatechange = function() {
          if (xhr.readyState !== 4) return
          if (xhr.status === 200) {
            const reader = new FileReader()
            reader.readAsDataURL(files[0])
            reader.onload = () => {
              onUploadComplete(reader.result, res.logoUrl)
            }
          }
          else {
            addGlobalMessage("An error occurred uploading your logo. Please try again.", "error")
          }
        };
        xhr.send(file)
      }
    )
  }
  return (
    <Dropzone accept={['.png', '.jpg', '.jpeg', '.gif']} onDrop={onDrop}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div
          {...getRootProps()}
          style={{
            maxWidth: '220px',
            maxHeight: '120px'
          }}
          className={
            "box-shadow rounded flex items-center justify-center p1 pointer " +
            (isDragActive ? "bg-gray-5" : "bg-white")
          }>
          <input {...getInputProps()}/>
          {isDragActive ? (
            <div>Drop files here...</div>
          ) : url ? (
            <img
              className='block'
              src={url}
              alt="Logo"
              style={{
                backgroundColor: backgroundColor,
                padding: '10px',
                maxHeight: '100%',
                maxWidth: '100%'
              }}/>
          ) : (
            <div className='center'>
              <span className='material-icons block muted'>image</span>
              <strong
                style={{
                  marginTop: '-0.5em'
                }}
                className='muted block'>
                No Logo
              </strong>
            </div>
          )}
        </div>
      )}
    </Dropzone>
  )
}

Logo.propTypes = {
  url: PropTypes.string,
  onUploadStart: PropTypes.func,
  onUploadComplete: PropTypes.func,
  organization: PropTypes.object,
  backgroundColor: PropTypes.string,
  addGlobalMessage: PropTypes.func,
  post: PropTypes.func
}


const mapStateToProps = state => ({
  organization: state.user.organization
})

const mapDispatchToProps = dispatch => ({
  addGlobalMessage: bindActionCreators(addGlobalMessage, dispatch),
  post: bindActionCreators(post, dispatch),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logo)

